<template>
  <div class="inline-block">
    <span @click="handleOpen">
      <slot></slot>
    </span>
    <el-dialog :title="title" :visible.sync="dialogVisible" width="60%" @close="close">
      <sirui-search
        v-if="searchColumns.length"
        ref="siruiSearch"
        :query="query"
        :columns="searchColumns"
        :colSpan="colSpan"
        :buttonSpan="buttonSpan"
        @resetBtnClick="resetBtnClick"
        @searchBtnClick="search"
        @changeChecked="changeChecked"
        @searchCompanyName="searchCompanyName"
        @changeMethod="changeMethod"
      ></sirui-search>
      <div class="main-content">
        <vxe-table
          ref="siruiTable"
          border
          resizable
          size="mini"
          :custom-config="{ storage: true }"
          :loading="load"
          :data="tableData"
          :tooltip-config="{ theme: 'light' }"
          :edit-config="{ trigger: 'click', mode: 'cell' }"
          :checkRowKeys="curCheckedKeys"
          :checkbox-config="checkboxConfig"
          height="400px"
        >
          <vxe-table-column
            v-if="isMultiple"
            type="checkbox"
            width="50"
            fixed="left"
          ></vxe-table-column>
          <vxe-table-column v-else type="radio" width="50" fixed="left"></vxe-table-column>
          <vxe-table-column
            v-for="(item, index) in columnList"
            :key="index"
            :type="item.type"
            :fixed="item.fixed"
            :field="item.prop"
            :title="item.label"
            :width="item.width || columnWidth"
            :sortable="item.sortable"
            :formatter="item.formatter"
            :visible="item.visible"
            :edit-render="item.editRender"
          >
            <template slot-scope="scope">
              {{ item.visible }}
              <span v-if="typeof item.render == 'function'">
                {{ item.render(scope.row[item.prop], scope.row) }}
              </span>
              <span v-else-if="item.dictType">
                {{ scope.row[item.prop] | getDictNameByCode(item.dictType) }}
              </span>
              <span v-else-if="item.format">
                {{ scope.row[item.prop] | formatTableColumn(item.format) }}
              </span>
              <span v-else>{{ scope.row[item.prop] }}</span>
            </template>
            <template v-slot:edit="scope">
              <InputNumberAd
                v-model="scope.row[item.prop]"
                v-if="item.prop == 'useAmount'"
                class="inputWidth"
                :controls="false"
                :precision="2"
                :disabled="isDisabled(scope.row['billCode'])"
                :min="0"
                :max="99999999999999999"
              ></InputNumberAd>
            </template>
          </vxe-table-column>
        </vxe-table>
        <el-pagination
          ref="page"
          background
          @size-change="handleSizeChange"
          @current-change="handlePagination"
          :page-count="page.pages"
          :current-page="page.pageNum || 1"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="page.pageSize"
          :total="page.total"
          layout="total, sizes, prev, pager, next, jumper"
        ></el-pagination>
      </div>
      <div slot="footer" ref="footer" class="dialog-footer">
        <el-button @click="close">{{ $t('dialog.cancel') }}</el-button>
        <el-button type="primary" @click="handleConfirm">{{ $t('dialog.confirm') }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import SiruiSearch from '@/components/SiruiSearch';
  // import SiruiTable from '@/components/SiruiTable';
  import { filterEmpty, toLine } from '@/common/js/util';
  import tradeApi from '@/api/receivablesAndPayables/trade.js';
  import InputNumberAd from '@/components/form-item/input-number-advance';
  export default {
    props: {
      checkboxConfig: {
        type: Object,
        default: () => {},
      },
      title: {
        // 弹窗标题
        type: String,
        default: () => '',
      },
      width: {
        // 弹窗宽度
        type: String,
        default: () => '1200px',
      },
      //搜索区域的内容
      searchColumns: {
        type: Array,
        default: () => [],
      },
      kpSelectId: {
        type: Array,
        default: () => [],
      },
      // 查询的接口
      API: {
        type: String,
        default: () => '',
      },
      getDataKey: {
        type: String,
        default: () => 'list',
      },
      // 额外参数
      extraData: {
        type: Object,
        default: () => {},
      },
      // 表格展示的内容
      columnList: {
        type: Array,
        default: () => [],
      },
      // 是否多选
      isMultiple: {
        type: Boolean,
        default: () => true,
      },
      // 外部控制弹窗是否显示
      defaultVisible: {
        type: Boolean,
        default: () => false,
      },
      // 表格列默认宽度
      columnWidth: {
        type: Number,
        default: undefined,
      },
      // 选中字段的key
      propCode: {
        type: String,
        default: 'id',
      },
      // 搜索默认分隔的colSpan，分成三列
      colSpan: {
        type: Number,
        default: 8,
      },
      // 右边按钮占位，弹窗占位需要宽一点
      buttonSpan: {
        type: Number,
        default: 4,
      },
      // 确认后是否选中，默认再次打开之前的还是选中的
      confirmUnchecked: {
        type: Boolean,
        default: true,
      },
      // 接口访问类型
      type: {
        type: String,
        default: 'post',
      },
      // 区分多个请求
      isManyApi: {
        type: Boolean,
        default: false,
      },
      // 填写过后的临时数据
      tempBillList: {
        type: Array,
        default: () => [],
      },
    },
    components: {
      SiruiSearch,
      // SiruiTable,
      InputNumberAd,
    },
    data() {
      return {
        dialogVisible: false,
        load: false,
        tableData: [],
        query: {},
        multipleSelection: [],
        curCheckedKeys: this.checkRowKeys,
        page: {
          pages: 1, //总共多少页
          pageNum: 1, //第几页
          pageSize: 10, //一页多少条数据
          total: 0, //总共多少条
        },
        // isDisabled:'',//已经选择过的数据无法输入
      };
    },
    watch: {
      defaultVisible() {
        if (this.defaultVisible) {
          this.handleOpen();
        }
        this.dialogVisible = this.defaultVisible;
      },
      checkRowKeys(newValue) {
        this.curCheckedKeys = newValue;
      },

      query: {
        handler(newValue) {
          this.$emit('changeQuery', newValue);
        },
        deep: true,
      },
    },
    computed: {
      // isDisabled(val) {
      //   const isDisabled = this.tempBillList.find((item) => item.billNo == val);
      //   return isDisabled;
      // },
    },
    mounted() {
      this.initQuery();
    },
    methods: {
      // 已经选择过的单据禁用输入框
      isDisabled(val) {
        const isDisabled = this.tempBillList.find((item) => item.billNo == val);
        if (isDisabled) return true;
        return false;
      },
      handleChange(row, val) {
        row['useAmount'] = val;
        // console.log(val);
      },
      // 点击分页
      handlePagination(val) {
        this.page.pageNum = val;
        this.getData();
      },
      // 分页条数改变
      handleSizeChange(val) {
        this.page.pageNum = 1;
        this.page.pageSize = val;
        this.getData();
      },
      handleOpen() {
        this.initQuery();
        this.dialogVisible = true;
        this.$nextTick(() => {
          this.getData();
        });
      },
      changeChecked() {
        this.getData();
      },
      searchCompanyName(val) {
        this.$emit('searchCompanyName', val);
      },
      changeMethod(val) {
        this.$emit('changeMethod', val);
      },
      // 初始化查询参数
      initQuery() {
        const query = {};
        this.searchColumns.forEach((item) => {
          if (item.prop) {
            if (typeof item.prop === 'string' && item.type != 'checkbox') {
              query[item.prop] = undefined;
            } else if (item.type == 'checkbox') {
              if (item.isChecked) {
                query[item.prop] = 1;
              } else {
                query[item.prop] = 0;
              }
            } else {
              item.prop.forEach((prop) => {
                query[prop] = undefined;
              });
            }
          }
        });
        this.query = Object.assign({}, query);
      },
      close() {
        this.dialogVisible = false;
        if (this.searchColumns[0]) this.$refs.siruiSearch.resetForm('queryFrom');
        this.$emit('close');
      },
      handleConfirm() {
        const curSelect = this.isMultiple
          ? this.$refs.siruiTable.getCheckboxRecords()
          : [this.$refs.siruiTable.getRadioRecord()];
        const prevSelectedList = this.$refs.siruiTable.getCheckboxReserveRecords(); // 历史选中数据
        const selectedList = curSelect.concat(prevSelectedList); // 选中数据
        // 点击后注入选中keys，再次打开保留选中，如果不需要则不操作
        if (this.confirmUnchecked) {
          this.curCheckedKeys = selectedList.map((item) => {
            return item[this.propCode];
          });
        }
        this.$emit('confirm', selectedList);
      },
      getData() {
        if (!this.API) return;
        const query = this.getQuery();
        const params = Object.assign({}, this.extraData, query);
        this.load = true;
        const url =
          this.isManyApi && params.settlementBusinessType != '01'
            ? tradeApi.RECEIVABLESLIST_QUERY
            : this.API;
        console.log(url, '111111111====>>>>', this.API, this.kpSelectId, this.tempBillList);
        this.$axios[this.type](url, params)
          .then((res) => {
            this.load = false;
            if (0 == res.data.code) {
              if (this.page) {
                this.tableData = res.data.data[this.getDataKey];
                if (this.kpSelectId.length != 0) {
                  this.tableData = this.tableData.filter(
                    (item) => !this.kpSelectId.includes(item?.id?.toString())
                  );
                }
                this.tableData = this.showAmount(this.tableData);
                this.$refs.siruiTable.reloadTable(this.tableData);
                this.page.total = res.data.data.total;
                console.log(this.tableData);
              } else {
                this.tableData = res.data.data;
                this.tableData = this.showAmount(this.tableData);
              }
            } else {
              this.$message({
                showClose: true,
                message: res.data.msg,
                type: 'error',
              });
            }
          })
          .catch(() => {
            this.load = false;
          });
      },

      showAmount(tableData) {
        tableData = tableData.map((item) => {
          // 填写使用金额后显示
          let useAmount = this.tempBillList.find((item1) => item1.billNo == item.billCode)?.amount;
          if (!item.useAmount) item.useAmount = useAmount;
          // 计算可用金额：票据金额-已占用金额
          let availableAmount = Number(item.billAmount) - Number(item.usedbillAmount) || 0;
          return {
            ...item,
            availableAmount: availableAmount >= 0 ? availableAmount : 0,
          };
        });
        return tableData;
      },
      // 获取查询参数
      getQuery() {
        // 分页数据
        const { pageNum, pageSize } = this.page;
        const query = this.query;
        const result = Object.assign({}, query, {
          pageNum,
          pageSize,
        });
        this.searchColumns.forEach((item) => {
          if (item.getSearchCode) {
            const arr = query[item.prop];
            if (arr && Array.isArray(arr) && arr.length) {
              const codes = arr.map((code) => {
                if (item.getSearchCode == 'partnerCode') {
                  return code.allPartnerCode ? code.allPartnerCode : code[item.getSearchCode];
                } else if (item.getSearchCode == 'productDetailCode') {
                  return code.allProductDetailCode
                    ? code.allProductDetailCode
                    : code[item.getSearchCode];
                } else {
                  return code[item.getSearchCode];
                }
              });
              // 单选改第一个，多选给多个
              result[item.prop] = item.isMultiple ? codes[0] : codes;
            }
          }
        });
        return filterEmpty(result);
      },
      // 表格排序
      sortChangeEvent({ property, order }) {
        let orderByDesc = '';
        if (order) {
          orderByDesc = `${toLine(property)} ${order}`;
        }
        const query = Object.assign({}, this.query, {
          orderByDesc,
        });
        this.query = query;
        this.getData();
      },
      // // 点击分页
      // handlePagination() {
      //   this.getData();
      // },
      // // 分页条数改变
      // handleSizeChange() {
      //   this.getData();
      // },
      // 搜索
      search() {
        // this.$refs.siruiTable.setPageNum(1);
        this.getData(true);
      },
      //双击单元格事件
      dblclickEvent(val) {
        this.$emit('dblclickEvent', val);
      },
      // 表格选中行
      handleSelectionChange(row) {
        this.multipleSelection = row;
      },
      // 重置
      resetBtnClick() {
        this.$emit('resetBtnClick');
        this.clearCheckboxReserve();
        this.multipleSelection = [];
        this.page.pageNum = 1;
        this.page.pageSize = 10;
        this.getData();
      },
      clearCheckboxReserve() {
        this.$refs.siruiTable.clearCheckboxRow();
        this.multipleSelection = [];
        console.log('调用');
      },
    },
  };
</script>
<style scoped lang="scss">
  .inline-block {
    display: inline-block;
  }
</style>
